export enum Color {
    WHITE = "var(--color-white)",
    GREY_LIGHT = "var(--color-grey-light)",
    GREY = "var(--color-grey)",
    GREY_DARK = "var(--color-grey-dark)",
    BLACK_LIGHTER = "var(--color-black-lighter)",
    BLACK_LIGHT = "var(--color-black-light)",
    MIDNIGHT_LIGHTER = "var(--color-midnight-lighter)",
    MIDNIGHT_LIGHT = "var(--color-midnight-light)",
    MIDNIGHT ="var(--color-midnight)",
    MIDNIGHT_DARK = "var(--color-midnight-dark)",
    GREEN = "var(--color-green)",
    LAVENDER = "var(--color-lavender)",
    LAVENDER_DARK = "var(--color-lavender-dark)",
    SAND = "var(--color-sand)",
    SAND_DARK = "var(--color-sand-dark)",
    CORAL_LIGHTER = "var(--color-coral-lighter)",
    CORAL_LIGHT = "var(--color-coral-light)",
    CORAL = "var(--color-coral)",
    LIME_LIGHT = "var(--color-lime-light)",
    LIME = "var(--color-lime)",
    LIME_DARK = "var(--color-lime-dark)",
    BLUE_LIGHT = "var(--color-blue-light)",
    BLUE = "var(--color-blue)",
    YELLOW_LIGHT = "var(--color-yellow-light)",
    YELLOW = "var(--color-yellow)",
    PURPLE_LIGHT = "var(--color-purple-light)",
    PURPLE = "var(--color-purple)",
    PINK_LIGHT = "var(--color-pink-light)",
    PINK = "var(--color-pink)",
    RED = "var(--color-red)",
    RED_DARK = "var(--color-red-dark)",
    ORANGE = "var(--color-orange)",
    ORANGE_DARK = "var(--color-orange-dark)",
    MUSTARD = "var(--color-mustard)",
    BROWN_LIGHT = "var(--color-brown-light)",
    BROWN = "var(--color-brown)",
    BROWN_DARK = "var(--color-brown-dark)",
    RASPBERRY_LIGHT = "var(--color-raspberry-light)",
    RASPBERRY = "var(--color-raspberry)",
    GARENCE = "var(--color-garence)",
    RUST_LIGHT = "var(--color-rust-light)",
    RUST = "var(--color-rust)",
    VIOLINE_LIGHT = "var(--color-violine-light)",
    VIOLINE = "var(--color-violine)",
    BLUEBERRY = "var(--color-blueberry)",
    CYAN = "var(--color-cyan)",
    CYAN_LIGHT = "var(--color-cyan-light)",
    CYAN_LIGHTER = "var(--color-cyan-lighter)",
    INFO_MAIN = "var(--color-info-main)",
    INFO_LIGHT = "var(--color-info-light)",
    INFO_LIGHTER = "var(--color-info-lighter)",
    DANGER_MAIN = "var(--color-danger-main)",
    DANGER_LIGHT = "var(--color-danger-light)",
    DANGER_LIGHTER = "var(--color-danger-lighter)",
    WARNING_MAIN = "var(--color-warning-main)",
    WARNING_LIGHT = "var(--color-warning-light)",
    WARNING_LIGHTER = "var(--color-warning-lighter)",
    SUCCESS_MAIN = "var(--color-success-main)",
    SUCCESS_LIGHT = "var(--color-success-light)",
    SUCCESS_LIGHTER = "var(--color-success-lighter)",
    OCEAN = "var(--color-ocean)",
    OCEAN_LIGHT = "var(--color-ocean-light)",
    OCEAN_LIGHTER = "var(--color-ocean-lighter)",
}